import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskService } from "./task.services";
import { TASK_KEYS } from "./task.keys";

export const useCreateTask = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: taskService.createTask,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [TASK_KEYS.TASKS],
      });
    },
  });
};

export const useUpdateTask = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: taskService.updateTask,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [TASK_KEYS.TASKS],
      });
    },
  });
};

export const useCreateNote = () => {
  return useMutation({
    mutationFn: taskService.createNote,
  });
};

export const useCompleteTask = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      taskId,
      payload,
    }: {
      taskId: string;
      payload: import("~/types/task").CompleteTaskPayload;
    }) => taskService.completeTask(taskId, payload),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [TASK_KEYS.TASKS],
      });
    },
  });
};

export const useDeleteTask = () => {
  return useMutation({
    mutationFn: taskService.deleteTask,
  });
};

export const useCreateDispatchNote = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: taskService.createDispatchNote,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [TASK_KEYS.TASKS],
      });
    },
  });
};
